export const FETCH_RESERVATION_TYPES = 'FETCH_RESERVATION_TYPES'
export const SET_MATCH_FIELD = 'SET_MATCH_FIELD'
export const VALID_MATCHER = 'VALID_MATCHER'
export const CLEAR_MATCH_FIELD = 'CLEAR_MATCH_FIELD'
export const CREATE_MATCHER_FOR_DISPLAY = 'CREATE_MATCHER_FOR_DISPLAY'
export const CHOOSE_DATE_TIME_FORMAT = 'CHOOSE_DATE_TIME_FORMAT'
export const CLEAR_TIMEZONE = 'CLEAR_TIMEZONE'
export const STORE_TZ = 'STORE_TZ'
export const FETCH_RESERVATION_TYPES_ACTION = 'getReservationTypes'
export const TRANSFORM_DATA_ACTION = 'transfromData'
export const CLEAR_MATCH_FIELDS_DATA = 'CLEAR_MATCH_FIELDS_DATA'
